import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { PieChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import BasicECharts from 'components/common/BasicEChart';
import {
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const getOptions = (data, radius, total) => {
  const color = data ? data.map(item => getColor(item.color)) : [];

  return {
    color,
    tooltip: {
      padding: [7, 10],
      transitionDuration: 0,
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('dark') },
      borderWidth: 1,
      formatter: params =>
        `<strong>${params.data.name}:</strong> ${params.percent}%`
    },

    series: [
      {
        name: total + ' хөтөч',
        type: 'pie',
        radius,
        avoidLabelOverlap: false,
        emphasis: {
          scale: false
        },
        itemStyle: {
          borderWidth: 2,
          borderColor: getColor('gray-100')
        },
        label: {
          show: true,
          position: 'center',
          formatter: '{a}',
          fontSize: 14,
          color: getColor('dark')
        },
        data
      }
    ]
  };
};

function selectColor(browser) {
  switch (browser) {
    case 'Chrome':
      return 'success';
    case 'Chrome Headless':
      return 'danger';
    case 'Mobile Safari':
      return 'primary';
    case 'Facebook':
      return '700';
    case 'Firefox':
      return 'info';
    case 'Safari':
      return 'warning';
    default:
      return 'secondary';
  }
}

const MarketShareItem = ({ item, index, total }) => {
  const { color, name } = item;
  // const converted = browser.split('/')[0] || browser;
  return (
    <Flex
      alignItems="center"
      justifyContent="between"
      className={`fw-semi-bold fs--2 ${index == 0 && 'mt-3'}`}
    >
      <p className="mb-1">
        <FontAwesomeIcon icon="circle" className={`me-2 text-${color}`} />
        {name}
      </p>
      <div className="d-xxl-none">{total}%</div>
    </Flex>
  );
};

const MarketShare = ({ browserAnalytics, radius }) => {
  const newData = browserAnalytics && browserAnalytics;
  const total = newData && newData.reduce((acc, val) => val?.count + acc, 0);
  const basicChartData =
    newData &&
    newData.map((value, index) => {
      const converted = value?.browser;
      return {
        id: index,
        value: value?.count,
        name: converted,
        color: selectColor(converted)
      };
    });

  const uniqueData =
    basicChartData &&
    basicChartData.reduce(
      (acc, current) => {
        if (
          current.name &&
          current.name !== 'undefined' &&
          !acc.names.includes(current.name)
        ) {
          acc.names.push(current.name);
          acc.result.push(current);
        }
        return acc;
      },
      { names: [], result: [] }
    ).result;

  return (
    <Card className="h-md-100">
      <Card.Body>
        <Row className="justify-content-between g-0">
          <Col xs={5} sm={6} xxl className="pe-2">
            <h6 className="mt-1">Нийт хөтөч</h6>
            {uniqueData &&
              uniqueData.map((item, index) => (
                <MarketShareItem
                  item={item}
                  index={index}
                  key={index}
                  total={total}
                />
              ))}
          </Col>
          <Col xs="auto">
            <div className="ps-0">
              <BasicECharts
                echarts={echarts}
                options={getOptions(uniqueData, radius, total)}
                style={{ width: '6.625rem', height: '6.625rem' }}
              />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

MarketShareItem.propTypes = {
  item: PropTypes.shape({
    color: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};

MarketShare.propTypes = {
  browserAnalytics: PropTypes.array,
  radius: PropTypes.array.isRequired
};

export default MarketShare;
